import React from "react"

export const handleIndexSocketResponse = (socketResponse, live, setUpdatedLivescoring) => {
    const isResultType = "resultado" === socketResponse.tipo
    const isRelatedCompetition = socketResponse.competicion === parseInt(live.compId)
    const isRelatedRound = socketResponse.jornada === parseInt(live.jornadaId)

    if (isResultType && isRelatedCompetition && isRelatedRound) {
        // Recargar datos de este livescoring específico
        const jornadaKey = "l-" + socketResponse.jornada
        
        const livescoringData = socketResponse.livescoringData

        setUpdatedLivescoring(prevUpdatedLivescoring => ({
            ...prevUpdatedLivescoring,
            [jornadaKey]: {
                ...prevUpdatedLivescoring[jornadaKey],
                jornadas: livescoringData[0],
                total: livescoringData[1],
                ordenClaves: livescoringData[2],
                ordenPosicion: livescoringData[3]
            }
        }))
    }
}
export const sectionLoader = () => {
    return <div className="loaderContainer">
        <div className="loader"></div>
    </div>
}

export const formatNumberWithDots = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}